import { getTemplate } from "../template-helper";
import Mustache from "mustache";
import { translateElement, tr } from "../../util/locales" ;
import { runInContext, getInstanceElement } from "../binding";
import { formatValue } from "../../util/formatter";

const COMPONENT_NAME = "z-search" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class SearchComponent extends HTMLElement {
            constructor() {
                super();
                this.innerHTML = "" ;
                this.currentValue = null ;
            }

            connectedCallback(){
                this.currentValue = null ;
                this.init() ;
            }

            init(){
                if(this.initDone){ return  ;}
                this.initDone = true ;
                const clone = document.importNode(template.content, true);
                this.appendChild(clone);

                const input = this.querySelector("input.search-input-dropdown") ;
                const divContainer = this.querySelector(".search-field") ;
                const buttonSearch = this.querySelector(".btn-search-field") ;

                this.inputValue = this.querySelector(".search-hidden-input") ;
                this.input = input ;
                this.buttonSearch = buttonSearch ;
                this.buttonSearchLabel = buttonSearch.querySelector("span") ;
                this.buttonSearchLabel.innerHTML = this.getAttribute("z-search-choose-label")||tr("global.pleaseChoose") ;
                this.divContainer = divContainer ;
                this.spinner = this.querySelector(".fa-pulse") ;
                this.ul = this.querySelector("ul") ;
                this.dropdownContainer = this.querySelector(".dropdown-menu") ;
                this.buttonRemove = this.dropdownContainer.querySelector("button") ;
                this.elPleaseTypeSearch = this.dropdownContainer.querySelector(".search-please-type") ;
                this.noEmptySearch = this.hasAttribute("z-no-empty-search") ;

                this.labelFields = (this.getAttribute("z-label-fields")||"").split(",").map(f=>f.trim()).filter(f=>!!f) ;
                this.fieldId = (this.getAttribute("z-field-id")||"_id") ;
                this.btnNew = this.querySelector(".z-btn-new");
                this.btnOpen = this.querySelector(".z-btn-open");

                this.btnNew.addEventListener("click", ()=>{
                    let createUrl = this.getAttribute("z-form-create-url") ;
                    if(createUrl){
                        let popupUrl = createUrl.replace(":mode", "create").replace(":id?", "") ;
                        let indexPoints = popupUrl.indexOf("/:") ;
                        if(indexPoints !== -1){
                            const instanceEl = getInstanceElement(this) ;
                            if(instanceEl && instanceEl.getData){
                                const instanceData = instanceEl.getData();
                                if(instanceData){
                                    while(indexPoints !== -1){
                                        let indexEnd = popupUrl.indexOf("/", indexPoints+2);
                                        let params;
                                        if(indexEnd !== -1){
                                            params = popupUrl.substring(indexPoints+2, indexEnd) ;
                                        }else{
                                            params = popupUrl.substring(indexPoints+2) ;
                                        }
                                        params = params.replace("?", "").replace(":", "") ;
                                        let value = ""+instanceData[params] ;
                                        let newUrl = popupUrl.substring(0, indexPoints)+"/"+value ;
                                        if(indexEnd !== -1){
                                            newUrl += popupUrl.substring(indexEnd) ;
                                        }
                                        popupUrl = newUrl;
                                        indexPoints = popupUrl.indexOf("/:") ;
                                    }
                                }
                            }
                        }
                        window.dialogs.viewDialog({route: popupUrl}, {
                            size: this.getAttribute("z-form-popup-size")||"fullscreen"
                        }, (createdRecord)=>{
                            if(createdRecord){
                                this.value = createdRecord._id ;
                                this.dispatchEvent(new Event("change", { bubbles: true }));
                            }
                        }) ;
                    }                    
                }) ;

                this.btnOpen.addEventListener("click", ()=>{
                    let formUrl = this.getAttribute("z-form-url") ;
                    if(formUrl && this.value){
                        formUrl = formUrl.replace(":mode", "read").replace(":id?", this.value) ;
                        window.open("#"+formUrl) ;
                    }                    
                }) ;

                
                buttonSearch.addEventListener("click", (ev)=>{
                    window.jQuery(buttonSearch).dropdown("dispose"); 
                    if(this.dropdownContainer.classList.contains("show")){
                        // this.divContainer.classList.remove("show");
                        this.dropdownContainer.classList.remove("show");
                        this.buttonSearch.parentElement.classList.remove("show");
                    }else{
                        this.divContainer.classList.add("show");
                        window.jQuery(buttonSearch).dropdown(); 
                        window.jQuery(buttonSearch).dropdown('toggle') ;
                    }
                    ev.preventDefault();
                    ev.stopPropagation() ;
                }) ;


                window.jQuery(divContainer).on('show.bs.dropdown', () => {
                    this.doSearch() ;
                }) ;
                window.jQuery(divContainer).on('shown.bs.dropdown', () => {
                    input.focus() ;
                    if(!this.noSelect){
                        input.select() ;
                    }
                    this.noSelect = false;
                }) ;

                input.addEventListener("change", (ev)=>{
                    ev.stopPropagation() ; //prevent change event to bubble outside z-search
                }) ;
                input.addEventListener("keyup", (ev)=>{
                    this.onInputKeyUp(ev) ;
                }) ;
                buttonSearch.addEventListener("keyup", (ev)=>{
                    this.onButtonKeyUp(ev) ;
                }) ;
                
                this.buttonRemove.addEventListener("click", ()=>{
                    this.onRemoveValue() ;
                }) ;


                translateElement(this) ;
                

                this.searchResults = [] ;
                this.value = this.getAttribute("value") ;

                this.applyReadOnly() ;
                this.applyRequired() ;
                this.applyNewOpen() ;
                if(this.customValidity){
                    this.setCustomValidity(this.customValidity) ;
                }

                // if(this.closest("form") !== null){
                //     this.input.onblur = ()=>{
                //         setTimeout(()=>{
                //                 this.divContainer.classList.remove("show");
                //                 this.dropdownContainer.classList.remove("show");
                //                 this.buttonSearch.parentElement.classList.remove("show");
                //         }, 150);
                //     };
                // }

                if (this.closest("body")) {
                    this.closest('body').addEventListener('click', function () {
                        // this.divContainer.classList.remove("show");
                        this.dropdownContainer.classList.remove("show");
                        this.buttonSearch.parentElement.classList.remove("show");
                    }.bind(this)) ;
                }
            }

            get value() {
                return this.currentValue ;
            }
            
            set value(value) {
                this.currentValue = value;
                if(!this.inputValue){
                    return;
                }
                this.inputValue.value = value ;
                if(!value){
                    this.buttonSearchLabel.innerHTML = this.getAttribute("z-search-choose-label")||tr("global.pleaseChoose") ;
                    if(this.getAttribute("value") !== ""){
                        this.removeAttribute('value');
                    }
                    this.buttonRemove.style.display = "none" ;
                }else{
                    this.buttonRemove.style.display = "" ;
                    let result = this.searchResults.find(s=>s.id == value) ;
                    if(result){
                        this.buttonSearchLabel.innerHTML = result.label ;
                    }else{
                        this.searchById(value).then((results)=>{
                            if(value === this.currentValue){
                                if(results.length>0){
                                    const result = results[0];
                                    this.buttonSearchLabel.innerHTML = result.label ;
                                }else{
                                    this.buttonSearchLabel.innerHTML = value ;
                                }
                            }
                        }).catch((err)=>{
                            throw err ;
                        }) ;
                    }
                    if(this.getAttribute("value") !== this.currentValue){
                        this.setAttribute('value', this.currentValue);
                    }
                }
                if(this.required && !this.currentValue){
                    this.querySelector("input").setCustomValidity(tr("global.thisFieldIsRequired"));
                }else{
                    this.querySelector("input").setCustomValidity("");
                }
                this.applyNewOpen() ;
            }

            get required() {
                return this.hasAttribute("required") ;
            }
            
            set required(required) {
                if(required){
                    this.setAttribute('required', required);
                }else{
                    this.removeAttribute('required');
                }
            }
            
            static get observedAttributes() {
                return ['value', 'readonly', "required", "z-form-route", "z-search-query"];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'value':
                        if(newValue !== this.currentValue){
                            this.value = newValue ;
                        }
                        break;
                    case 'required':
                        this.applyRequired();
                        break;
                    case 'readonly':
                        this.applyReadOnly() ;
                        this.applyNewOpen() ;
                        break;
                    case 'z-form-route':
                        this.applyNewOpen() ;
                        break;
                    /*case 'z-search-query':
                        this.checkValueFilter() ;
                        break;*/
                }
            }

            applyReadOnly(){
                if(!this.buttonSearch){ return ; }
                if(this.hasAttribute("readonly")){
                    this.buttonSearch.disabled = true;
                }else{
                    this.buttonSearch.disabled = false;
                }
            }

            searchById(id){
                if(this.getAttribute("z-search-function")){
                    //custom function 
                    return this.searchInDatabase("").then((results) => {
                        return results.map(v=>this.mapValue(v)).filter(s=>s.id == id) ;
                    }).catch((err)=>{
                        throw err ;
                    }) ;
                }else{
                    let resourceUrl = this.getAttribute("z-resource-url") ;
                    resourceUrl += "/?"+this.fieldId+"="+encodeURIComponent(id) ;
                    return fetch(resourceUrl, {credentials: 'include'}).then(function(response) {
                        return response.json();
                    }).then((results)=>{
                        return results.map(v=>this.mapValue(v)) ;
                    }).catch((err)=>{
                        throw err ;
                    }) ;
                }
            }

            searchInDatabase(searchText){
                let promiseSearch = null;
                if(this.getAttribute("z-search-function")){
                    let functionResult ;
                    try{
                        functionResult = runInContext(this, {searchText}, this.getAttribute("z-search-function")) ;
                    } catch(err){
                        promiseSearch = Promise.reject(err) ;
                    }
                    if(functionResult && functionResult.constructor === Promise){
                        promiseSearch = functionResult ;
                    }else if(functionResult){
                        promiseSearch = Promise.resolve(functionResult) ;
                    }else{
                        Promise.reject("Function "+this.getAttribute("z-search-function")+" must return results !") ;
                    }
                }else{
                    let resourceUrl = this.getAttribute("z-resource-url") ;
                    let queryObj = null;
                    let queryString = "" ;
                    if(this.hasAttribute("z-search-query")){
                        queryString = this.getAttribute("z-search-query") ;
                        if(queryString[0]==="{" && queryString[queryString.length-1]==="}"){
                            queryObj = JSON.parse(queryString) ;
                            queryString = "" ;
                        }
                    }else if(!resourceUrl.includes("{{search}}")){
                        queryObj = { limit: 100, $or: [] } ;
                        for(let labelField of this.labelFields){
                            
                            if(labelField.includes("{{")){
                                //use template syntax, extract field
                                let extractedFields = labelField.match(/\{\{([a-zA-Z0-9_]*?)\}\}/gm).map(function(str){ return str.replace(/\{/g, "").replace(/\}/g, ""); }) ;
                                for(let f of extractedFields){
                                    let labelSearch = {} ;
                                    labelSearch[f] = "%{{search}}%" ;        
                                    queryObj.$or.push(labelSearch) ;
                                }
                            }else{
                                let labelSearch = {} ;
                                labelSearch[labelField] = "%{{search}}%" ;
                                queryObj.$or.push(labelSearch) ;
                            }
                        }
                    }
                    if(!queryString && queryObj){
                        queryString = Object.keys(queryObj).map((key)=>{
                            let value = queryObj[key] ;
                            if(typeof(value) !== "string"){
                                value = JSON.stringify(value) ;
                            }
                            return key+"="+encodeURIComponent(value) ;
                        }).join("&") ;
                    }
                    if(queryString){
                        let searchQuery = "?"+queryString.replace(/%7B%7Bsearch%7D%7D/g, "{{search}}") ;
                        resourceUrl += searchQuery ;
                    }
    
                    resourceUrl = resourceUrl.replace(/{{search}}/g, encodeURIComponent(searchText.replace(/"/g, "\""))) ;
                    promiseSearch = fetch(resourceUrl, {credentials: 'include'}).then((response) => {
                        return response.json();
                    });
                }
                return promiseSearch ;
            }

            /* don't check on filter anymore. if the value exists, let it be
            checkValueFilter(){
                if(!this.value){ return Promise.resolve() ; }
                if(!this.hasAttribute("z-search-query")){ return Promise.resolve() ; }
                if(this.getAttribute("z-search-query")[0] !== "{"){ return Promise.resolve() ; }

                let resourceUrl = this.getAttribute("z-resource-url") ;
                let queryString = this.getAttribute("z-search-query") ;
                if(queryString[0]==="{" && queryString[queryString.length-1]==="}"){
                    let queryObj = JSON.parse(queryString) ;
                    delete queryObj.limit;
                    queryObj = { $and : [queryObj, {_id: this.value}]} ;
                    queryString = Object.keys(queryObj).map((key)=>{
                        let value = queryObj[key] ;
                        if(typeof(value) !== "string"){
                            value = JSON.stringify(value) ;
                        }
                        return key+"="+encodeURIComponent(value) ;
                    }).join("&") ;
                }
                let searchQuery = "?"+queryString.replace(/%7B%7Bsearch%7D%7D/g, "{{search}}") ;
                resourceUrl += searchQuery ;

                resourceUrl = resourceUrl.replace(/{{search}}/g, "") ;
                return fetch(resourceUrl, {credentials: 'include'}).then((response) => {
                    return response.json();
                }).then((results)=>{
                    if(results.length === 0){
                        //not found, it was removed by filter
                        this.value = null;
                    }
                });
            }*/

            formatObj(obj){
                Object.keys(obj).forEach(k=>{
                    const val = obj[k] ;
                    if(val && ({}).constructor === val.constructor){
                        this.formatObj(val) ;
                    }else{
                        obj[k] = formatValue(obj[k]) ;
                    }
                });
            }

            mapValue(r){
                if(!r){
                    return {
                        id: null,
                        label: ""
                    } ;
                }
                
                var labelField = this.labelFields.map(function(f){ 
                    if(f.includes("{{")){ return f; }
                    return "{{"+f+"}}" ;
                }).join(" - ") ;
                Mustache.parse(labelField);
                let formattedRecord = JSON.parse(JSON.stringify(r)) ;
                this.formatObj(formattedRecord) ;
                var label = Mustache.render(labelField, formattedRecord); 
                return {
                    id: r[this.fieldId||"id"],
                    label: label 
                } ;
            }
            doSelect(result){
                let changed = false;
                if(!result || this.currentValue == result.id){
                    this.currentValue = null;
                    this.value = null;
                    changed = true;
                }else if(this.value != result.id){
                    this.currentValue = result.id;
                    this.value = result.id ;
                    changed = true;
                }
                this.divContainer.classList.remove("show");
                this.dropdownContainer.classList.remove("show");
                this.buttonSearch.parentElement.classList.remove("show");
                if(changed){
                    this.dispatchEvent(new Event('change', {bubbles: true}));
                }
                if(this.required && !this.currentValue){
                    this.querySelector("input").setCustomValidity(tr("global.thisFieldIsRequired"));
                }else{
                    this.querySelector("input").setCustomValidity("");
                }
                this.renderResults();
            }
            onRemoveValue(){
                this.doSelect(null) ;
            }
            doSearch(){
                const searchText = this.input.value ;
                this.currentSearch = searchText ;
                const lastHeight = this.dropdownContainer.offsetHeight ;
                setTimeout(() => {
                    if(this.noEmptySearch && !searchText.trim()){
                        this.elPleaseTypeSearch.style.display = "";
                        this.searchResults = [] ;
                        this.renderResults() ;
                        this.spinner.classList.add("d-none") ;
                        this.selectedEntryIndex = -1;
                        return;
                    }else{
                        this.elPleaseTypeSearch.style.display = "none";
                    }
                    if(this.currentSearch !== searchText){ return ;} //this search is obsolete
                    if(this.startedSearch === searchText){ return ;} //this search is already running
                    this.startedSearch = searchText ;
                    this.spinner.classList.remove("d-none") ;
                    this.searchInDatabase(searchText).then((results) => {
                        if(this.currentSearch === searchText){
                            delete this.startedSearch ;
                            if(results.length>100){
                                this.searchResults = results.slice(0, 100) ;
                            }else{
                                this.searchResults = results ;
                            }
                            this.searchResults = this.searchResults.map(v=>this.mapValue(v)) ;
                            this.spinner.classList.add("d-none") ;
                            this.selectedEntryIndex = -1;
                            this.renderResults() ;
                            if(lastHeight !== this.dropdownContainer.offsetHeight){
                                if(this.dropdownContainer.hasAttribute("x-placement")){
                                    window.jQuery(this.buttonSearch).data("bs.dropdown")._popper.options.placement = this.dropdownContainer.getAttribute("x-placement") ;
                                }
                                window.jQuery(this.buttonSearch).data("bs.dropdown")._popper.scheduleUpdate() ;
                            }
                        }
                    }).catch((err)=>{
                        throw err ;
                    }) ;
                }, 250) ;
            }

            renderResults(){
                let lis = this.ul.querySelectorAll("li") ;
                for(let i = 0 ; i<this.searchResults.length; i++){
                    let li = lis[i] ;
                    const searchResult = this.searchResults[i] ;
                    if(!li){
                        li = document.createElement("LI") ;
                        li.addEventListener("click", (ev)=>{
                            this.doSelect(this.searchResults[i]) ;
                        }) ;
                        this.ul.appendChild(li) ;
                    }
                    let liHtml = searchResult.label ;
                    if(searchResult.id === this.currentValue){
                        liHtml += ' <i class="fas fa-check"></i>' ;
                        li.classList.add("selected") ;
                    }else{
                        li.classList.remove("selected") ;
                    }
                    if(i === this.selectedEntryIndex){
                        li.classList.add("keyboardSelected") ;
                    }else{
                        li.classList.remove("keyboardSelected") ;
                    }
                    li.innerHTML = liHtml ;
                }
                for(let i = this.searchResults.length; i<lis.length; i++){
                    this.ul.removeChild(lis[i]) ;
                }
                this.lis = this.ul.querySelectorAll("li") ;
            }

            onInputKeyUp(ev) {
                if(ev.keyCode === 40){
                    //arrow down
                    
                    //remove old selected mark
                    if(this.lis && this.lis[this.selectedEntryIndex]){
                        this.lis[this.selectedEntryIndex].classList.remove("keyboardSelected") ;
                    }

                    this.selectedEntryIndex ++ ;
                    if(this.selectedEntryIndex >= this.searchResults.length){
                        this.selectedEntryIndex = this.searchResults.length - 1 ;
                    }

                     //add new selected mark
                     if(this.lis && this.lis[this.selectedEntryIndex]){
                        this.lis[this.selectedEntryIndex].classList.add("keyboardSelected") ;
                    }

                }else if(ev.keyCode === 38){
                    //arrow up
                    
                    //remove old selected mark
                    if(this.lis && this.lis[this.selectedEntryIndex]){
                        this.lis[this.selectedEntryIndex].classList.remove("keyboardSelected") ;
                    }

                    this.selectedEntryIndex-- ;
                    if(this.selectedEntryIndex < 0){
                        this.selectedEntryIndex = 0 ;
                    }

                    //add new selected mark
                    if(this.lis && this.lis[this.selectedEntryIndex]){
                        this.lis[this.selectedEntryIndex].classList.add("keyboardSelected") ;
                    }
                }else if(ev.keyCode === 13){
                    //enter key
                    if(this.searchResults.length>0 && this.selectedEntryIndex>=0 && this.selectedEntryIndex<this.searchResults.length){
                        this.doSelect(this.searchResults[this.selectedEntryIndex]) ;
                    }else if(this.searchResults.length>0){
                        this.doSelect(this.searchResults[0]) ;
                    }
                } else {
                    this.doSearch() ;
                }
            }
            onButtonKeyUp(ev){
                if(ev.keyCode === 9 || ev.keyCode === 16  || ev.keyCode === 27){ return ;}

                if(ev.keyCode !== 40 && ev.keyCode !== 38 && ev.keyCode !== 13){
                    this.input.value = ev.key ;
                }
                this.noSelect = true;
                this.buttonSearch.click() ;
            }


            select(){
                if(this.input && this.input.select){
                    this.input.select() ;
                }
            }
            focus(){
                if(this.input && this.input.focus){
                    this.input.focus() ;
                }
            }
            checkValidity(){
                if(this.input && this.input.checkValidity){
                    return this.input.checkValidity() ;
                }
                return true;
            }

            applyRequired(){
                const required = this.hasAttribute("required") ;
                if(this.inputValue){
                    if(required){
                        this.inputValue.setAttribute("required", "required") ;
                    }else{
                        this.inputValue.removeAttribute("required") ;
                    }
                }
            }

            setCustomValidity(msg){
                this.customValidity = msg ;
                if(this.inputValue){
                    this.inputValue.setCustomValidity(msg) ;
                }
            }
            

            applyNewOpen(){
                if(!this.btnOpen){ return ; }

                const formUrl = this.hasAttribute("z-form-url") ;
                const createUrl = this.hasAttribute("z-form-create-url") ;
                if(formUrl && this.value){
                    this.btnOpen.style.display = "block" ;
                }else{
                    this.btnOpen.style.display = "none" ;
                }
                if(createUrl && !this.hasAttribute("readonly")){
                    this.btnNew.style.display = "block" ;
                }else{
                    this.btnNew.style.display = "none" ;
                }
            }
        }
        customElements.define(COMPONENT_NAME, SearchComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
